export const environment = {
  production: false,
  API_ENDPOINT_V1: 'https://api.dev.agronodo.mx/api/v1/',
  API_ENDPOINT_V2: 'https://api.dev.agronodo.mx/v2/',
  API_ENDPOINT: `https://api.dev.agronodo.mx/`,
  SOCKET_URL: `ws://api.dev.agronodo.mx/ws/main-socket/`,
  apikeyMap: 'AIzaSyCgvUmbX0bwZ-E4W5t8piopEDVeV4L5YfQ',
};

